import { thermostatsApi } from '@/api';

const analysesThermostatsSearchFilters = [
  {
    name: 'groupingId',
    label: 'grouping',
    type: 'text',
    whereOperator: '=',
  },
  {
    name: 'labSampleCode',
    label: 'sampleId',
    type: 'text',
    whereOperator: 'regexp',
  },
  {
    name: 'analysisCode',
    label: 'analysisId',
    type: 'text',
    whereOperator: 'regexp',
  },
  {
    name: 'analysisDescription',
    label: 'analysisDescriptionFull',
    type: 'text',
    whereOperator: 'regexp',
  },
  {
    name: 'startedAt',
    label: 'startedAt',
    type: 'dateDay',
    whereOperator: 'gt',
  },
  {
    name: 'endedAt',
    label: 'endedAt',
    type: 'dateDay',
    whereOperator: 'lt',
  },
  {
    name: 'temperatureTrailId',
    label: 'temperatureTrailId',
    type: 'number',
    whereOperator: '=',
  },
  {
    name: 'thermostatName',
    label: 'thermostat',
    type: 'autocomplete',
    whereOperator: '=',
    autocompleteSearch: async (queryString, cb) => {
      const response = await thermostatsApi.autocompleteFetch(queryString);
      const thermostats = response.data.map((item) => ({
        label: item.name,
        value: item.name,
      }));
      cb(thermostats);
    },
  },
  {
    name: 'temperature',
    label: 'temperature',
    type: 'number',
    whereOperator: '=',
  },
];

export default analysesThermostatsSearchFilters;
